export default "__VITE_ASSET__f0f45dff__"